import { isNumber, isRequiredFieldTrueInObject } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (isNumber(values.cutoffPeriod, true)) {
    errors.cutoffPeriod = 'Cutoff period can be only number';
  }

  if (isRequiredFieldTrueInObject(values.days || '', true)) {
    errors.days = 'Select days is required';
  }

  return errors;
};

export default validate;
